<template>
  <v-card>
    <v-card-title>Editar Combustivel</v-card-title>
    <v-container flex>
      <v-form lazy-validation v-model="valid" ref="formCombustivel">
        <v-layout row wrap fill-height justify-space-between>
          <v-flex xs12>
            <v-text-field
              label="Nome"
              :rules="[(v) => !!v || 'Esse campo é obrigatório']"
              v-model="dadosCombustivel.nome"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Referência"
              :rules="[(v) => !!v || 'Esse campo é obrigatório']"
              v-model="dadosCombustivel.ref"
              required
            ></v-text-field>
          </v-flex>
          <v-flex sm12>
            <v-select :items="icones" v-model="dadosCombustivel.icone" label="Icone" single-line>
              <template slot="selection" slot-scope="data">
                <v-flex xs2>
                  <v-avatar color="grey" size="25px">
                    <img :src="require(`@/assets/combs/${data.item.value}.svg`)" />
                  </v-avatar>
                </v-flex>
                <v-flex class="ml-1">{{ data.item.text }}</v-flex>
              </template>
              <template slot="item" slot-scope="data">
                <v-list-tile-avatar color="grey">
                  <img :src="require(`@/assets/combs/${data.item.value}.svg`)" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.text"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </v-select>
          </v-flex>
          <v-flex xs12>
            <strong>Escolha uma cor base:</strong>
            <swatches v-model="dadosCombustivel.color" inline />
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Tipo do volume"
              hint="Exemplo: 'L' para Litros"
              v-model="dadosCombustivel.tipo_volume"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Descrição do volume"
              hint="Exemplo: 'Litros' para o tipo de volume L"
              v-model="dadosCombustivel.descricao_volume"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
    <v-card-actions>
      <v-btn flat color="info" @click="fechar()">Voltar</v-btn>
      <v-spacer></v-spacer>
      <v-btn flat color="info" @click="atualizarCombustivel()">Confirmar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import { combustivelDao } from '@/api'
import Swatches from 'vue-swatches'

export default {
  components: { Swatches },
  data () {
    return {
      valid: false,
      id_combustivel: null,
      dadosCombustivel: {
        nome: null,
        icone: null,
        color: null,
        descricao: null,
        tipo_volume: null,
        descricao_volume: null,
        ref: null
      },
      icones: [
        {
          text: 'Álcool',
          value: 'alcool'
        },
        {
          text: 'Gasolina',
          value: 'gas'
        },
        {
          text: 'Diesel',
          value: 'diesel'
        },
        {
          text: 'Gás Natural',
          value: 'gasnatural'
        }
      ]
    }
  },
  watch: {
    combustivel (val) {
      if (val) {
        this.id_combustivel = this.combustivel.id_combustivel
        this.dadosCombustivel.nome = this.combustivel.nome
        this.dadosCombustivel.icone = this.combustivel.icone
        this.dadosCombustivel.color = this.combustivel.color
        this.dadosCombustivel.tipo_volume = this.combustivel.tipo_volume
        this.dadosCombustivel.descricao_volume = this.combustivel.descricao_volume
        this.dadosCombustivel.ref = this.combustivel.ref
      }
    }
  },
  computed: {
    combustivel () {
      return this.$store.getters.combustivel
    },
    headers () {
      return this.$store.getters.headers
    }
  },
  mounted () {
    if (this.combustivel) {
      this.id_combustivel = this.combustivel.id_combustivel
      this.dadosCombustivel.nome = this.combustivel.nome
      this.dadosCombustivel.icone = this.combustivel.icone
      this.dadosCombustivel.color = this.combustivel.color
      this.dadosCombustivel.tipo_volume = this.combustivel.tipo_volume
      this.dadosCombustivel.descricao_volume = this.combustivel.descricao_volume
      this.dadosCombustivel.ref = this.combustivel.ref
    }
  },
  methods: {
    fechar () {
      this.$refs.formCombustivel.reset()
      this.$store.dispatch('selectCombustivel', null)
      this.$emit('fechar')
    },
    atualizarCombustivel () {
      if (this.$refs.formCombustivel.validate()) {
        combustivelDao.atualizarCombustivel(this.id_combustivel, this.dadosCombustivel, this.headers)
          .then(response => {
            if (response.ok) {
              this.$emit('complete', 'Combustivel atualizado com sucesso')
              this.fechar()
            } else {
              this.$emit('error', 'Não foi possível atualizar o combustível')
              this.fechar()
            }
          })
      }
    }
  }
}
</script>
